// extracted by mini-css-extract-plugin
export default {"box":"guide_box__j2otL","guide_head":"guide_guide_head__TgtgP","gridbox":"guide_gridbox__8Fs+G","p_bold":"guide_p_bold__Xco51"};